import React, {useEffect, useState} from "react";
import {updatePreferenceData} from "../../../../services/CommonService";
import {toast} from "react-toastify";
import Utils from "../../../../utils";

function EnvelopeProtected(props) {

    const [isProtected, setIsProtected] = useState(1);

    useEffect(function () {

        setIsProtected((props?.preferenceData.envelope_protected) ? parseInt(props?.preferenceData.envelope_protected) : 1);

    }, [props?.preferenceData]);

    const handleUpdateProtected = (e) => {
        setIsProtected(e.target.checked);

        props.setLoading(true);

        let updateList = [
            {slug: 'envelope_protected', value: (e.target.checked) ? 1 : 0}
        ];

        updatePreferenceData({list: updateList})
            .then(response => {
                props.setLoading(false);
                toast.success(response.data.message);
            })
            .catch(err => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    return (
        <div className="tab-pane setting-tab-pane" id="EnvelopeProtection" role="tabpanel">

        <div className="setting-card">
      
          {/* SECTION TITLE */}
          <div className="setting-section-title">
            Sleeve Protection
          </div>
      
          {/* PROTECTION SWITCH ROW */}
          <div className="setting-row">
      
            <div className="setting-col">
              <p className="setting-label-bold">Sleeve Password Protected</p>
              <p className="setting-text">
                Protect sleeve with a password. The recipient will create a password.
              </p>
            </div>
      
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={isProtected}
                  onChange={handleUpdateProtected}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
      
          </div>
      
        </div>
      
      </div>
      
    );
}

export default EnvelopeProtected;